import Vue from "vue";

import _ from "lodash";
import cf from "@/helpers/conf";
import fn from "@/helpers/func";
import VueMq from "vue-mq";
import Intersect from "vue-intersect";
import VueAwesomeSwiper from "vue-awesome-swiper";
import Swiper, {
  Navigation,
  Pagination,
  Scrollbar,
  EffectFade,
  Autoplay
} from "swiper";
import "swiper/swiper-bundle.css";
import VueCookies from "vue-cookies";
import SlideUpDown from "vue-slide-up-down";
import PortalVue from "portal-vue";
import VueMeta from "vue-meta";
import MarqueeText from "vue-marquee-text-component";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCafS1FUd644OyagUCmyo_HCqAwYAOsIPI",
    libraries: "places" // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
});
import moment from "moment";

Vue.use(moment);
Vue.use(VueMeta);
Vue.component("marquee-text", MarqueeText);
Vue.component("slide-up-down", SlideUpDown);
Vue.use(require("vue-moment"), {
  moment
});
var vueMoment = require("moment");
require("moment/locale/en-au");
require("moment/locale/en-ca");
require("moment/locale/en-gb");
require("moment/locale/ka");

Vue.prototype.$fn = fn;
Vue.prototype.$cf = cf;

Vue.use(_);
Vue.prototype._ = _;
Vue.use(VueAwesomeSwiper);
Vue.use(Intersect);
Vue.use(VueCookies);
Vue.use(PortalVue);

Swiper.use([Navigation, Pagination, Scrollbar, EffectFade, Autoplay]);
Vue.use(VueMq, {
  breakpoints: {
    phone: 767,
    tablet: 1024,
    md: 1365,
    lg: 1599
  },
  defaultBreakpoint: "sm" // customize this for SSR
});
Vue.component("slide-up-down", SlideUpDown);
